export default __webpack_public_path__ + "static/media/LogoFoleja.a5a6e66c.svg";